module.exports = __webpack_public_path__ + "img/canhBao.5d554f71.png";